/**
 * The one place an exact decimal string becomes a floating-point number.
 *
 * Money is carried as a string from the ledger to the screen precisely so that
 * nothing rounds it on the way. Drawing is the single exception: an SVG
 * coordinate is a float whatever we do, and a path cannot be plotted from
 * strings.
 *
 * So the conversion exists once, here, and every chart calls it. A second copy
 * somewhere else would be the beginning of a system where money is "sometimes"
 * a number — which is how a figure on one screen starts disagreeing with the
 * same figure on another.
 *
 * A converted value is geometry and nothing else. It is never rendered, never
 * compared against a threshold and never summed.
 */
export function finiteGeometryValue(value: string): number | null {
  const numericValue = Number(value);
  return Number.isFinite(numericValue) ? numericValue : null;
}
